import { createContext, type ReactNode, type RefObject, useRef } from "react";
import type { ContentNode } from "react-to-print/lib/types/ContentNode";

// eslint-disable-next-line react-refresh/only-export-components
export const PrintScheduleTimeSlotsContentRefContext = createContext<
  RefObject<ContentNode> | undefined
>(undefined);

export function PrintScheduleTimeSlotsContentRefProvider(props: {
  children: ReactNode;
}): ReactNode {
  const printableContentRef = useRef<HTMLDivElement | null>(null);
  return (
    <PrintScheduleTimeSlotsContentRefContext.Provider
      value={printableContentRef}
    >
      <div ref={printableContentRef}>{props.children}</div>
    </PrintScheduleTimeSlotsContentRefContext.Provider>
  );
}
